// src/services/gatoodleTermineService.js
// Termine-Verwaltung für "El Gatoodle" gegen das Postgres-Schema "gatoodle"
// (Tabelle termine). Ersetzt azureGatoodleTermineService.js — siehe
// gatoodleGuestsService.js für den Hintergrund der Migration.
const BASE_URL = "/api/gatoodle/termine";

export const DEFAULT_MAX_PLAETZE = 8;

async function parseErrorMessage(response, fallback) {
  try {
    const data = await response.json();
    return data?.error || fallback;
  } catch {
    return fallback;
  }
}

const toBody = (terminData) => ({
  datum: terminData.datum,
  uhrzeit: terminData.uhrzeit || "",
  programm: terminData.programm || "",
  oeffnungVon: terminData.oeffnungVon || "",
  oeffnungBis: terminData.oeffnungBis || "",
  maxPlaetze: Number(terminData.maxPlaetze) || DEFAULT_MAX_PLAETZE,
});

// Alle Termine laden, aufsteigend nach Datum, inkl. Belegung (Abgleich).
export const getAllTermine = async () => {
  const response = await fetch(BASE_URL);
  if (!response.ok) {
    throw new Error("Die Termine konnten nicht geladen werden.");
  }
  return response.json();
};

// Neuen Termin anlegen.
export const createTermin = async (terminData) => {
  const response = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(toBody(terminData)),
  });
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response, "Der Termin konnte nicht gespeichert werden."));
  }
  return response.json();
};

// Termin aktualisieren.
export const updateTermin = async (id, terminData) => {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(toBody(terminData)),
  });
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response, "Der Termin konnte nicht aktualisiert werden."));
  }
  return response.json();
};

// Termin löschen (Anmeldungen kaskadieren serverseitig).
export const deleteTermin = async (id) => {
  const response = await fetch(`${BASE_URL}/${id}`, { method: "DELETE" });
  if (!response.ok && response.status !== 404) {
    throw new Error("Der Termin konnte nicht gelöscht werden.");
  }
  return true;
};
